import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import app from "./modules/app";
import meta from "./modules/meta";
import { vuexfireMutations } from "vuexfire";
// import firebase from "firebase";
import edm from "@/store/modules/edm";
import emailTemplates from "@/store/modules/emailTemplates";

Vue.use(Vuex);

export default new Vuex.Store({
  mutations: {
    // other mutations
    ...vuexfireMutations
  },
  modules: {
    user,
    app,
    edm,
    meta,
    emailTemplates
  }
  // state: () => ({
  //   meta: {}
  // }),
  // actions: {
  //   bindMeta: firebaseAction(({ bindFirebaseRef }) => {
  //     // binds the documents collection onto the `state.documents` property
  //     // `bindFirebaseRef` also automatically unbinds any previously bound reference on the same property `documents`
  //     bindFirebaseRef("meta", firebase.database().ref("_meta"));
  //   })
  // },
  // getters: {
  //   projects: state => {
  //     return state.meta.projects;
  //   },
  //   projectArray: state => {
  //     if (!state.meta || !state.meta.projects) {
  //       return [];
  //     }
  //     const projects = state.meta.projects;
  //     const arr = [];
  //     for (let k in projects) {
  //       const p = projects[k];
  //       p.id = k;
  //       arr.push(p);
  //     }
  //     return arr;
  //   },
  //   leadSources: state => state.meta.leads.sources
  // }
});
